import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Page from '@/components/Page'
import Project from '@/components/Project'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'commissions',
      component: Index,
      meta: {
        action: 'getCommissions'
      }
    },
    {
      path: '/projects',
      name: 'projects',
      component: Index,
      meta: {
        action: 'getProjects'
      }
    },
    {
      path: '/work/:slug',
      name: 'commission',
      component: Project,
      meta: {
        type: 'commissions'
      }
    },
    {
      path: '/projects/:slug',
      name: 'project',
      component: Project,
      meta: {
        type: 'projects'
      }
    },
    {
      path: '/desk',
      name: 'desk',
      component: Page
    },
    {
      path: '/contact',
      name: 'contact',
      component: Page
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(savedPosition || { x: 0, y: 0 })
      }, 40)
    })
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js